/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** Configuration files */
import { createRenewalConfig } from "./CreateContractRenewal.formfield.config";
import { ServiceLocationContext } from "../../../../../../../utils/context/ServiceLocationContext";
import { getDropdownValue } from "../../../../../../../components/finalForms/libs/data/dropdownUtilities";
import { useGetContractAgreementTemplateMutation } from "../../../../../../../app/services/contractAPI";
import { setFieldSetting } from "../../../../../../../utils/formFieldUtils/ManageFields";
import { setDropdownOptions } from "../../../../../../../components/finalForms/libs/data/mapDropdownOptions";
import { FieldSettingType } from "../../../../../../../components/finalForms/libs/data/fieldSettingType";
import ToastService from "../../../../../../../services/toastService/ToastService";
import PropTypes from "prop-types";

const CreateRenewal = ({ onClose }) => {
  const CreateRenewalRef = useRef();

  const { selectedLocation } = useContext(ServiceLocationContext);
  const locationkey = getDropdownValue(selectedLocation);

  const [agreementTemplateFormData, setAgreementTemplateFormData] = useState(createRenewalConfig)

  const [getAllContractAgreementTemplate, {
    isFetching: isAllContractAgreementTemplateFetching,
    isSuccess: isAllContractAgreementTemplateFetched,
    data: AllContractAgreementTemplateData,
  }] = useGetContractAgreementTemplateMutation();

  useEffect(() => {
    if (locationkey) {
      getAllContractAgreementTemplate(locationkey);
      setFieldSetting(agreementTemplateFormData, 'lPendingContractAgreementTemplateKey', FieldSettingType.ISFIELDDATALOADING, true);
    }
  }, [locationkey])

  useEffect(() => {
    if (!isAllContractAgreementTemplateFetching && isAllContractAgreementTemplateFetched && AllContractAgreementTemplateData) {
      setDropdownOptions(AllContractAgreementTemplateData, 'lPendingContractAgreementTemplateKey', 'sPendingContractAgreementTemplate', agreementTemplateFormData, 'lPendingContractAgreementTemplateKey', setAgreementTemplateFormData);
      setFieldSetting(agreementTemplateFormData, 'lPendingContractAgreementTemplateKey', FieldSettingType.ISFIELDDATALOADING, false);
    }
  }, [isAllContractAgreementTemplateFetching, isAllContractAgreementTemplateFetched, AllContractAgreementTemplateData])

  const handleSave = () => {
    const formData = CreateRenewalRef.current.getFormData();
    if (!formData) {
      ToastService.error("Please fill all required fields");
    }
  }

  return (
      <div className="row">
        <FormCreator ref={CreateRenewalRef} config={agreementTemplateFormData} />
        <div className="d-flex justify-content-end gap-3 export-icon">
          <Buttons
            buttonText="Save"
            onClick={handleSave}
            buttonTypeClassName="btn blue-btn"
            titleText="Save"
          // isLoading={isDeleting}
          />
          <Buttons
            buttonText="Cancel"
            onClick={onClose}
            buttonTypeClassName="btn blue-btn"
            titleText="Cancel"
          // isLoading={isDeleting}
          />
        </div>
      </div>
  );
};

CreateRenewal.prototype={
  onClose:PropTypes.func
};

export default CreateRenewal;
